import { combineReducers } from 'redux'
import uiFlags from './uiFlags'
import stagedSettings from './stagedSettings'

export default combineReducers({
  uiFlags,
  stagedSettings,
})
